{
  "actions": {
    "approve": "Approuver",
    "reject": "Rejeter",
    "return": "Renvoyer",
    "cancel": "Annuler",
    "delegate": "Déléguer",
    "escalate": "Escalader",
    "cancelRequest": "Annuler la demande",
    "resubmit": "Resoumettre pour approbation",
    "editResubmit": "Modifier et resoumettre",
    "reviewResubmit": "Examiner et resoumettre",
    "viewInInbox": "Voir dans la boîte de réception"
  },
  "form": {
    "commentsPlaceholder": "Commentaires (facultatif)",
    "delegateRequired": "Sélectionnez un employé à qui déléguer"
  },
  "status": {
    "pending": "En attente",
    "approved": "Approuvé",
    "rejected": "Rejeté",
    "returned": "Renvoyé",
    "cancelled": "Annulé",
    "completed": "Terminé",
    "draft": "Brouillon",
    "submitted": "Soumis",
    "escalated": "Escaladé",
    "done": "Terminé"
  },
  "entity": {
    "leave": "Congé",
    "attendance": "Présence",
    "expense": "Note de frais",
    "overtime": "Heures supplémentaires",
    "payroll": "Paie"
  },
  "inbox": {
    "title": "Boîte d'approbation",
    "type": "Type",
    "employee": "Employé",
    "step": "Étape",
    "status": "Statut",
    "submitted": "Soumis",
    "sla": "SLA",
    "actions": "Actions",
    "onlyMine": "Assigné à moi",
    "submittedByMe": "Soumis par moi",
    "delegatedToMe": "Délégué à moi",
    "allStatuses": "Tout",
    "timeline": "Chronologie d'approbation",
    "noItems": "Aucun élément d'approbation ne correspond à vos filtres",
    "actionDone": "Demande {{status}}",
    "resubmitted": "Resoumis · {{status}}",
    "failedLoad": "Échec du chargement des approbations",
    "actionFailed": "Échec de l'action d'approbation",
    "delegations": "Délégations",
    "builder": "Concepteur de flux"
  },
  "toast": {
    "workflowUpdated": "Workflow mis à jour",
    "workflowCreated": "Workflow créé",
    "workflowActivated": "Flux de travail activé",
    "workflowDeactivated": "Flux de travail désactivé",
    "workflowCloned": "Flux de travail cloned",
    "delegationCreated": "Delegation créé",
    "delegationDeactivated": "Delegation désactivé",
    "resubmittedForApproval": "Resubmitted pour approbation",
    "attendanceUpdatedResubmitWhenReady": "Présence mis à jour — resubmit when ready",
    "leaveUpdatedResubmitWhenReady": "Congé mis à jour — resubmit when ready",
    "requestStatus": "Demande {{status}}"
  },
  "errors": {
    "aWorkflowMustHaveAtLeastOneApproval": "A flux de travail must have at least one approbation step",
    "codeAndNameAreRequired": "Le code et le nom sont requis",
    "addAtLeastOneApprovalStep": "Ajoutez au moins un approval step",
    "selectAnOrgRoleForEachStepThat": "Sélectionnez un org role for each step that uses specific org role",
    "enterAUserIdForEachStepThat": "Saisissez a user ID for each step that uses Specific user",
    "selectARoleForSlaReassignment": "Sélectionnez un role for sla reassignment",
    "selectAnEmployeeWithALoginAccountFor": "Sélectionnez un employee with a login account for sla reassignment",
    "failedToLoadWorkflows": "Échec du chargement de workflows",
    "failedToSaveWorkflow": "Échec de l'enregistrement de workflow",
    "activateFailed": "Échec de l'activation",
    "deactivateFailed": "Échec de la désactivation",
    "cloneFailed": "Échec du clonage",
    "delegateEmployeeAndEndDateAreRequired": "Delegate employé et end date are requis",
    "failedToCreateDelegation": "Échec de la création de delegation",
    "failedToDeactivateDelegation": "Échec : deactivate delegation",
    "failedToLoadApprovalMatrix": "Échec du chargement de approval matrix",
    "approvalActionFailed": "Échec de approval action",
    "checkInTimeIsRequired": "L'heure d'arrivée est requise",
    "checkOutMustBeAfterCheckIn": "Le départ doit être après l'arrivée",
    "failedToUpdateAttendance": "Échec de la mise à jour de attendance",
    "leaveTypeAndAtLeastOneDayAre": "Le type de congé et au moins un jour sont requis",
    "leaveReasonIsRequired": "Le motif de congé est requis",
    "failedToUpdateLeave": "Échec de la mise à jour de leave",
    "selectedEmployeeNoUserAccount": "Selected employé has no utiliserr account linked",
    "cannotDelegateToYourself": "Cannot delegate à yourself",
    "failedToLoadEmployees": "Échec du chargement de employees"
  },
  "pages": {
    "approvalWorkflows": "Flux d'approbation",
    "approvalDelegations": "Délégations d'approbation",
    "approvalMatrix": "Matrice d'approbation",
    "myApprovals": "Mes approbations",
    "pendingApprovals": "Approbations en attente"
  },
  "matrix": {
    "description": "Qui approuve quoi dans {{module}} — action, conditions, approbateurs, SLA et escalade",
    "openBuilder": "Ouvrir le concepteur",
    "empty": "Aucun flux d'approbation configuré. Créez des flux dans le concepteur d'approbation."
  },
  "builder": {
    "description": "Concevez les chaînes d'approbation {{module}} sans code — séquentiel, parallèle ou hybride",
    "editWorkflow": "Modifier le flux",
    "createWorkflow": "Créer un flux",
    "updateWorkflow": "Mettre à jour le flux",
    "workflowsTitle": "Flux {{module}}",
    "empty": "Aucun flux pour l'instant — créez votre première chaîne d'approbation",
    "stepDefaultName": "Étape {{order}}",
    "stepLabel": "Étape {{order}}",
    "stepNameLabel": "Nom de l'étape {{order}}",
    "conditionTitle": "Condition (facultatif)",
    "stepsTitle": "Étapes d'approbation",
    "stepsHelp": "Définissez qui approuve chaque étape. Utilisez le responsable hiérarchique ou choisissez un rôle organisationnel dans Organisation → Rôles.",
    "addStep": "Ajouter une étape",
    "remove": "Supprimer",
    "approvers": "Approbateurs",
    "addApprover": "Ajouter un approbateur",
    "approverN": "Approbateur {{n}}",
    "clone": "Dupliquer",
    "archived": "Archivé",
    "assigneeNotConfigured": "Non configuré",
    "assigneeSelectRole": "Sélectionnez un rôle organisationnel ci-dessous",
    "assigneeRoleCode": "Rôle : {{code}}",
    "assigneeUserId": "ID utilisateur {{id}}",
    "assigneeEnterUserId": "Saisissez l'ID utilisateur de l'approbateur"
  },
  "approvalTypes": {
    "SEQUENTIAL": "Séquentiel",
    "PARALLEL": "Parallèle",
    "HYBRID": "Hybride"
  },
  "policies": {
    "missing": {
      "AUTO_APPROVE": "Approuver automatiquement si l'approbateur est absent",
      "BLOCK_SUBMISSION": "Bloquer la soumission (erreur de configuration)",
      "ESCALATE": "Escalader au niveau suivant / règle SLA"
    },
    "sla": {
      "AUTO_APPROVE": "Approbation automatique (directe)",
      "REASSIGN": "Réassigner à un autre approbateur",
      "NOTIFY": "Prolonger le SLA (rappel)"
    }
  },
  "conditions": {
    "equals": "Égal à",
    "inList": "Dans la liste"
  },
  "escalateTo": {
    "orgRole": "Rôle organisationnel",
    "specificEmployee": "Employé spécifique"
  },
  "table": {
    "action": "Action",
    "name": "Nom",
    "type": "Type",
    "status": "Statut",
    "workflow": "Flux",
    "conditions": "Conditions",
    "approvers": "Approbateurs",
    "sla": "SLA",
    "escalation": "Escalade",
    "active": "Actif",
    "inactive": "Inactif"
  },
  "timeline": {
    "empty": "Aucune action enregistrée pour l'instant.",
    "delegatedTo": "Délégué à",
    "by": "Par",
    "unknownUser": "Utilisateur inconnu",
    "userRef": "Utilisateur n°{{id}}",
    "actions": {
      "SUBMIT": "Demande soumise",
      "APPROVE": "Approuvé",
      "AUTO_APPROVE": "Approuvé automatiquement",
      "REJECT": "Rejeté",
      "RETURN": "Renvoyé pour correction",
      "REQUEST_CHANGES": "Modifications demandées",
      "DELEGATE": "Délégué",
      "ESCALATE": "Escaladé",
      "SLA_AUTO_APPROVE": "Approuvé automatiquement (SLA expiré)",
      "SLA_ESCALATE": "Réassigné (SLA expiré)",
      "SLA_NOTIFY": "Rappel SLA",
      "CANCEL": "Annulé",
      "RESUBMIT": "Resoumis",
      "COMMENT": "Commentaire ajouté",
      "SYSTEM_NOTE": "Note système"
    }
  },
  "returned": {
    "title": "Renvoyé pour modification",
    "defaultComment": "L'approbateur vous a demandé de réviser cette demande avant de la resoumettre.",
    "editRequest": "Modifier la demande",
    "essLeavePrefix": "Ou ouvrez",
    "essLeaveLink": "congés en libre-service",
    "essLeaveSuffix": "pour modifier depuis votre portail.",
    "resubmitHint": "Enregistrez d'abord les modifications, puis resoumettez pour relancer l'approbation."
  },
  "guide": {
    "title": "Guide des types d'approbateurs",
    "subtitle": "Qui reçoit la demande, pourquoi, et un exemple concret pour chaque type.",
    "hide": "Masquer le guide",
    "show": "Afficher tous les types",
    "example": "Exemple :",
    "resolvesTo": "Cette étape se résout en :",
    "flowHint": "Chaque demande indique qui doit l'approuver ensuite sous En attente chez — résolu via la hiérarchie, les rôles ou les utilisateurs nommés sur l'étape du flux."
  },
  "inboxExt": {
    "description": "Boîte d'approbation pour {{module}} — uniquement les demandes pour vous et votre équipe",
    "view": "Vue",
    "refresh": "Actualiser",
    "pendingWith": "En attente chez",
    "overdue": "En retard",
    "stepN": "Étape {{n}}",
    "emptyView": "Aucune demande d'approbation dans cette vue",
    "myQueueOnly": "Ma file uniquement",
    "allRequests": "Toutes les demandes",
    "slaDeadline": "Échéance SLA",
    "currentStep": "Étape actuelle",
    "details": "Détails",
    "overdueSuffix": "(en retard)",
    "kpiPendingForMe": "En attente pour moi",
    "kpiDelegatedToMe": "Délégué à moi",
    "kpiSubmittedByMe": "Soumis par moi",
    "kpiReturnedToMe": "Renvoyé à moi",
    "kpiApprovedByMe": "Approuvé par moi",
    "kpiRejectedByMe": "Rejeté par moi",
    "kpiMyActions": "Mes actions"
  },
  "labels": {
    "code": "Code",
    "name": "Nom",
    "action": "Action",
    "approvalType": "Approbation type",
    "slaHours": "SLA (heures)",
    "afterSlaExpires": "Après expiration du SLA",
    "escalateTo": "Escalader vers",
    "escalationRole": "Rôle d'escalade",
    "escalationEmployee": "Employé d'escalade",
    "missingApproverPolicy": "Politique si approbateur absent",
    "stepGroupSameGroupParallel": "Groupe d'étapes (même groupe = parallèle)",
    "approverType": "Type d'approbateur",
    "orgRole": "Rôle organisationnel",
    "approverUserId": "ID utilisateur approbateur",
    "selectRole": "Sélectionner un rôle",
    "selectEmployee": "Sélectionner un employé",
    "reason": "Motif",
    "effectiveUntil": "Effectif jusqu'au",
    "selectDelegate": "Sélectionner un délégué",
    "checkIn": "Arrivée",
    "checkOut": "Départ",
    "timeline": "Chronologie"
  }
}
